<template>
<div class="page page_income">
    <!-- 头部 -->
	<div class="top">
		<div class="txt">总收入：￥<span class="cash">{{totalPrice}}</span></div>
	</div>
	<!-- 日期选择 -->
	<!-- <div class="riqi" @click="show = true">{{ date }}</div> -->
	<!-- 内容区 -->
	<!-- <van-tabs v-model="active" :border="false">
		<van-tab title="商城收入" :name="0"></van-tab>
		<van-tab title="云支付" :name="1"></van-tab>
		<van-tab title="约·看" :name="2"></van-tab>
		<van-tab title="视频" :name="3"></van-tab>
	</van-tabs> -->
	<div class="list">
		<!-- <div class="list_top">
			<div class="name">商城总收入</div>
			<div class="price"><span class="tag_cash">¥</span>{{totalPrice}}</div>
		</div> -->
		<ul class="order" v-for="item in dataList" :key="item.id">
			<li class="item">
				<div class="item_l">
					<div class="bianhao">订单编号  {{item.order_num}}</div>
					<div class="time">{{item.created_at}}</div>
				</div>
				<div class="item_r price">¥{{item.money}}</div>
			</li>
		</ul>
	</div>
    <!-- 列表 -->
    <!-- <div class="jiangren">
        <div class="con" v-for="income in dataList" :key="income.id">
            <div class="con_info clearfix">
                <div class="f-l con_info_r">
                    <div class="name">{{ income.title }}</div>
                    <div class="name">{{ income.price }}</div>
                    <div class="name">{{ income.date }}</div>
                </div>
            </div>
        </div>
    </div> -->
	<!-- 日期 弹层 -->
	<van-popup v-model="show" position="bottom">
		<van-datetime-picker
		v-model="currentDate"
		type="year-month"
		 @confirm="confirmDate" @cancel="show=false"
		/>
	</van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
			dataList: [],
			date: null, // 日期
			show: false, // 日期弹层
			currentDate: new Date(), // 当天日期
            active: 0,
            finished: false,
            page: 1,
            size: 10,
            loading: false,
			refreshing: false,
			totalPrice: 0
        };
    },
	mounted(){
		this.date = this.format(new Date())
	},
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "收入明细"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var param = {
				token: this.token,
                type: 2 , // 1城市合伙人2代理商户(默认1) 3一级经销商
                page: this.page,
                size: this.size
            }
            this.$api.my.incomeList(param).then(res => {
                if (res.code == 200) {
                    this.totalPrice = res.result.sum
                    var list = res.result.list
                    if (this.page == 1) {
                        this.dataList = list
                    } else {
                        var old = this.dataList
                        for (let i = 0; i < list.length; i++) {
                            old.push(list[i])
                        }
                        this.dataList = old
                    }
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished = true
                        this.refreshing = false
                        return;
                    }
                } else {
                    this.finished = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading = false;
            })
		},
		// 确认日期
		confirmDate(value){
			console.log(value)
			this.date = this.format(value)
			this.show = false
		},
		// 日期格式  data是日期对象  返回格式2020-05
		format(data){
			var year = data.getFullYear();
			var month = data.getMonth() + 1
			if(month.toString().length == 1){
				month = '0' + month
			}
			return year+'-'+month
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page_income .order .item{
	justify-content: space-between;
}
</style>
